import http from "../http-common";
/* eslint-disable */
class JadwalKonsultasiService {
  jadwalList(page, itemPerPage, hari, dokter) {
    return http.get(
      "/konsultasi-jadwal/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&hari=" +
        hari +
        "&dokter=" +
        dokter,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("user_id", data.selectedDokter.id);
    bodyFormData.append("hari", data.selectedHari.code);
    bodyFormData.append("jam_awal", data.jam_awal);

    return http.post("/konsultasi-jadwal", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("user_id", data.selectedDokter.id);
    bodyFormData.append("hari", data.selectedHari.code);
    bodyFormData.append("jam_awal", data.jam_awal);

    return http.put(`/konsultasi-jadwal/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/konsultasi-jadwal/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new JadwalKonsultasiService();
